namespace AgerLMS.WebSite {

    export interface ResetPasswordWidgetRequest {
    }

    //https://ajax.aspnetcdn.com/ajax/jquery.validate/1.11.1/additional-methods.js
    @Serenity.Decorators.registerClass()
    export class ResetPasswordWidget extends Serenity.Widget<ResetPasswordWidgetRequest> {

        button : string = "#ResetPasswordButton";
        formSelector : string = "#ResetPasswordForm";

        constructor(element: JQuery, opt: ResetPasswordWidgetRequest) {
            super(element, opt);

            var form = $(this.formSelector);

            this.bindValidate();

            $(this.button).click(e => {
                e.preventDefault();

                // $("#ResetPasswordForm").submit();
                if (!$(this.formSelector).valid()) return;

                var userRow = <Administration.UserRow>{};
                userRow.Email = form.find("input[name='email']").val();
                userRow.MobilePhoneNumber = form.find("input[name='phone']").val();

                Administration.PublicUserService.CheckUserForResetPasswordSMS({ Entity: userRow }, response => {
                    // Kullanıcı kayıt için uygun ise
                    this.checkResetPasswordSMS(userRow.MobilePhoneNumber + "#" + userRow.Email, response.Guid, response.Message, 
                        (r) => {
                            var rsp = <Serenity.RetrieveResponse<string>>r;
                            //Q.notifySuccess("Şifreniz başarıyla sıfırlandı. Yeni şifreniz ile giriş yapabilirsiniz.");
                            window.location.href = Q.resolveUrl('~/new-password?t=' + rsp.Entity);
                            // Administration.PublicUserService.UserSave({ Entity: userRow }, () => {
                            //     //Kullanıcı kayıt işlemi başarılı ise yönlendirme yapılacak
                            //     Swal.fire({
                            //         title: 'Kullanıcı Oluşturuldu! Sistemi Kullanmaya Başlayabilirsiniz.',
                            //         text: 'Giriş sayfasına yönleniyor. Lütfen Bekleyiniz...',
                            //         icon: 'success',
                            //         timer: 2000,
                            //         buttons: false,
                            //     })
                            //     .then(() => {
                            //         window.location.href = Q.resolveUrl('~/giris');
                            //     })
                                
                            // }, { onError: (e) => { SweetAlert.swal_alert("Hata", e.Error.Message); } });
                        }
                    );
                }, 
                { 
                    onError: response => {
                        SweetAlert.swal_alert(response.Error.Message, response.Error.Message)
                    }
                });
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $("#ResetPasswordButton").click();
                }
            });
        }

        private bindValidate() {
            var self = this;

            $.validator.addMethod('trPhone', function(value, element) {
                return value.match(/05[0-9]{8}/);
            },"Geçerli telefon numarası girin. SMS ile doğrulama kodu alacaksınız.");

            $("#ResetPasswordForm").validate({
                errorClass: "is-invalid",
                rules: {
                    email: {
                        required: true,
                        email: true
                    },
                    phone: { required : true, trPhone : true, minlength: 11, maxlength: 11 },           
                },
                messages: {
                    email: {
                        required: "* Sizinle iletişim kurmak için e-posta adresinize ihtiyacımız var!",
                        email: "* E-posta adresiniz student@agerlms.com biçiminde olmalıdır!"
                    },
                    phone: {
                        required: "* Sizinle iletişim kurmak için cep telefonunuz gereklidir!",
                        trPhone: "* Geçerli bir cep telefonu numarası girin! Sms ile doğrulama kodu alacaksınız.",
                        minlength : "* Geçerli bir cep telefonu numarası girin! Sms ile doğrulama kodu alacaksınız.",
                        maxlength: "* Geçerli bir cep telefonu numarası girin! Sms ile doğrulama kodu alacaksınız."
                    }
                }
            });
        }

        protected checkResetPasswordSMS(user: string, registerAuthGuid: string, message: string, onSuccess: (r) => void) {
            var tries = 0;
            let timerInterval
            var sw = Swal.fire({
                title: 'Şifre Sıfırlama SMS Doğrulama',
                html: message,
                timer: 2 * 60 * 1000,
                timerProgressBar: true,
                input: 'text',
                inputAttributes: {
                  autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Kodu Onayla',
                cancelButtonText: 'İptal',
                showLoaderOnConfirm: true,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('span.counter')
                    timerInterval = setInterval(() => {
                      b.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
                    }, 1000)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                },
                preConfirm: (x) => {
                    if (x >= 1000 && x <= 9999) {
                        tries++;
                        
                        Q.serviceCall({
                            url: Q.resolveUrl('~/Services/Administration/PublicUser/CheckSmsForResetPassword'),
                            request: {
                                Username: user,
                                Guid: registerAuthGuid,
                                Code: x
                            },
                            onSuccess: (r) => {
                                onSuccess(r);
                                return true;
                            },
                            onError: (z: Serenity.ServiceResponse) => {
                                if (tries > 2) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: 'Girilen kod geçersiz! 3 defadan fazla deneyemezsiniz!',
                                      })
                                    return true;
                                }
                                Swal.showValidationMessage(`${z.Error.Message}`)

                                // sw();
                            }
                        });
                
                        return false;
                    }
                    else Swal.showValidationMessage(`Lütfen geçerli bir kod girin!`)
                },
                allowOutsideClick: () => !Swal.isLoading(),
            }).then(r => {
                // Q.notifyInfo(JSON.stringify(r));
            });
        }
    }
}